import { repairGermanProductUI } from '@theme/zentus-german-product-locale';
class ZentusRolyTechnicalTable extends HTMLElement {
  #controller;
  #labels;
  #sizeNames;

  connectedCallback() {
    repairGermanProductUI(this);
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#labels = JSON.parse(this.querySelector('[data-technical-labels]')?.textContent || '{}');
    const guide = this.closest('.shopify-section, dialog')?.querySelector(`zentus-size-guide[data-product-id="${this.dataset.productId}"]`);
    this.#sizeNames = new Map(Array.from(guide?.querySelector('[data-state]')?.content.querySelectorAll('[data-size]') || [], row => [row.dataset.optionId, row.dataset.size]));
    this.closest('.shopify-section, dialog')?.addEventListener('variant:update', this.#update, { signal: this.#controller.signal });
    const pending = this._zentusPendingVariant;
    delete this._zentusPendingVariant;
    if (pending) this.#applyUpdate(pending.source, pending.guide);
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #update = (event) => {
    if (event.detail?.data?.productId && String(event.detail.data.productId) !== this.dataset.productId) return;
    const source = event.detail?.data?.html;
    const updated = source?.querySelector(`zentus-roly-technical-table[data-product-id="${this.dataset.productId}"]`);
    if (!updated) return;
    this.#applyUpdate(updated, source.querySelector(`zentus-size-guide[data-product-id="${this.dataset.productId}"]`));
  };

  #applyUpdate(source, guide) {
    // Clone the shared response so other variant listeners can still read it.
    const updated = source.cloneNode(true);
    const incomingLabels = JSON.parse(updated.querySelector('[data-technical-labels]')?.textContent || '{}');
    const label = (selector, key) => {
      if (this.#labels[key] === undefined) return;
      for (const element of updated.querySelectorAll(selector)) element.textContent = this.#labels[key];
    };
    label('caption', 'title');
    label('.zentus-technical-table__note', 'packaging_note');
    label('.zentus-technical-table__children', 'children');
    ['size', 'pack', 'carton', 'measurements', 'carton_dimensions', 'carton_weight'].forEach((key, index) => label(`thead th:nth-child(${index + 1})`, key));
    const region = updated.querySelector('.zentus-technical-table__scroll');
    if (region && this.#labels.title !== undefined) region.setAttribute('aria-label', this.#labels.title);
    for (const cell of updated.querySelectorAll('tbody td')) {
      if (incomingLabels.not_supplied !== undefined && cell.textContent.trim() === incomingLabels.not_supplied && this.#labels.not_supplied !== undefined) cell.textContent = this.#labels.not_supplied;
    }
    for (const row of guide?.querySelector('[data-state]')?.content.querySelectorAll('[data-size]') || []) {
      const name = this.#sizeNames.get(row.dataset.optionId);
      if (name === undefined || !row.dataset.variantId) continue;
      const heading = updated.querySelector(`tr[data-variant-id="${CSS.escape(row.dataset.variantId)}"] > th`);
      if (heading) {
        for (const node of [...heading.childNodes]) if (node.nodeType === Node.TEXT_NODE) node.remove();
        heading.prepend(document.createTextNode(name + ' '));
      }
    }
    const metadata = updated.querySelector('[data-technical-labels]');
    if (metadata) metadata.textContent = JSON.stringify(this.#labels);
    const scroll = this.querySelector('.zentus-technical-table__scroll');
    const scrollLeft = scroll?.scrollLeft || 0;
    this.hidden = updated.hidden;
    repairGermanProductUI(updated);
    this.replaceChildren(...updated.childNodes);
    const replacement = this.querySelector('.zentus-technical-table__scroll');
    if (replacement) replacement.scrollLeft = scrollLeft;
  }
}

if (!customElements.get('zentus-roly-technical-table')) customElements.define('zentus-roly-technical-table', ZentusRolyTechnicalTable);
